import React from 'react';
import '../styles/hero.css';

const Hero = () => {
    return (
        <section className="hero">
            <div className="hero-intro">
                <h2 className="subtitle"> 
                   Welcome to my portfolio, I am an AI engineer in making ...
                </h2>
            </div>
        </section>
    );
}

export default Hero;
